import {apiRequest} from "../services/apiRequest";

export const ProfileUpdate = {
    updatePassword: async (data) =>  await apiRequest('patch', "/account/profile/password/", data),
  };    